import React, { useContext } from 'react';
import { IconProps } from '../iconProps';
import { UiContext } from 'shared/lib/contexts/uiContext';
import cx from 'classnames';
import { defaultSpacingPresets } from 'shared/hooks/useGetSpacing';

export default function IconMP4({
  isAutoscallable = true,
  sizeKey = '18x22',
  onClick,
  style,
}: IconProps) {
  const {
    spacings: {
      icons: { [sizeKey]: size },
    },
  } = useContext(UiContext);

  const w = isAutoscallable ? size.w : defaultSpacingPresets.icons[sizeKey].w;
  const h = isAutoscallable ? size.h : defaultSpacingPresets.icons[sizeKey].h;

  return (
    <svg
      className={cx('icon', { 'icon-disabled': !onClick })}
      onClick={onClick}
      style={style}
      width={w}
      height={h}
      viewBox="0 0 18 22"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.4219 5.78944V20.263C17.4219 21.2224 16.6416 22 15.6794 22H2.32059C1.35809 22 0.578125 21.2224 0.578125 20.263V1.73697C0.578125 0.777562 1.35809 0 2.32059 0H11.6135L17.4219 5.78944Z"
        fill="#435055"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.2928 14.9411V15.6534H13.4506V14.9411H11.2826V14.3031C11.2599 14.5279 11.2214 14.7404 11.1478 14.9256C11.0419 15.1931 10.89 15.3973 10.6923 15.5382C10.4947 15.6791 10.2589 15.7496 9.98422 15.7496C9.62225 15.7496 9.31356 15.6369 9.05781 15.4107V16.8816H8.25275V12.3915H8.99525V12.7115C9.14513 12.583 9.30256 12.4819 9.46791 12.4084C9.63325 12.3348 9.823 12.298 10.0372 12.298C10.451 12.298 10.7663 12.4431 10.9825 12.7335C11.1987 13.0237 11.307 13.4455 11.307 13.9989C11.307 14.0391 11.2991 14.0735 11.2977 14.1127L13.3915 11.3496H14.2928V14.1886H14.8232V14.9411H14.2928ZM10.3118 13.2698C10.2015 13.0924 10.0372 13.0041 9.81888 13.0041C9.68791 13.0041 9.55316 13.0347 9.41497 13.0955C9.27644 13.1567 9.1575 13.232 9.05781 13.321V14.7483C9.14306 14.8253 9.24859 14.893 9.37441 14.9521C9.50022 15.0112 9.62947 15.0408 9.76284 15.0408C9.98319 15.0408 10.1575 14.947 10.2853 14.7593C10.4132 14.5716 10.4772 14.3224 10.4772 14.0116C10.4772 13.6943 10.4222 13.4472 10.3118 13.2698ZM13.4506 12.5001L12.1406 14.1886H13.4506V12.5001ZM7.07919 13.7315C7.07919 13.539 7.06784 13.3884 7.04516 13.2808C7.02213 13.1729 6.98741 13.1 6.94066 13.0615C6.89356 13.023 6.81622 13.0041 6.70794 13.0041C6.58522 13.0041 6.45528 13.0495 6.31813 13.1409C6.18097 13.232 6.05309 13.344 5.9345 13.4767V15.6534H5.12944V13.7315C5.12944 13.52 5.12016 13.3674 5.10159 13.2729C5.08269 13.1787 5.04934 13.1103 5.00156 13.0677C4.95378 13.0254 4.87266 13.0041 4.75819 13.0041C4.6585 13.0041 4.543 13.0419 4.41203 13.1175C4.28106 13.1931 4.13841 13.3128 3.98475 13.4767V15.6534H3.17969V12.3915H3.98475V12.8143C4.13428 12.6524 4.29138 12.5263 4.45569 12.4348C4.62 12.3437 4.80184 12.298 5.00156 12.298C5.27416 12.298 5.47525 12.3448 5.60519 12.4379C5.73513 12.5314 5.82416 12.6693 5.87194 12.8515C6.05928 12.6651 6.23425 12.5263 6.39788 12.4348C6.56081 12.3437 6.75194 12.298 6.97022 12.298C7.28853 12.298 7.52022 12.3884 7.66597 12.5685C7.81138 12.749 7.88425 13.0515 7.88425 13.4767V15.6534H7.07919V13.7315Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.4211 5.46528V6.18578H12.6729C11.6897 6.18578 11.2363 5.38828 11.2363 4.40481V0H11.9555L17.4211 5.46528Z"
        fill="#8F9CA1"
      />
    </svg>
  );
}
